import { Box } from '@factorialco/deprecated-design-system'
import {
  ContractHistoryActivityPeriodFragment,
  JobCatalogTreeLevelNodeFragment,
} from 'generated/resources/graphql'

import { Contract } from 'modules/contracts/components/NewContractHistory/types'
import ContractVersionContract from 'modules/contracts/lib/contractVersionContract'

import ActivityPeriod from './ActivityPeriod'

interface Props {
  contract: Contract
  firstContract: boolean
  onContractVersionSelect?: (referenceVersionId: string | undefined) => void
  selectedContractVersionId: string | undefined
  contractOngoingActivityPeriod?: ContractHistoryActivityPeriodFragment | undefined
  jobCatalogTreeLevelNodes?: JobCatalogTreeLevelNodeFragment[]
}

const ContractView = ({
  contract,
  firstContract,
  onContractVersionSelect,
  selectedContractVersionId,
  contractOngoingActivityPeriod,
  jobCatalogTreeLevelNodes,
}: Props) => {
  const contractContract = ContractVersionContract.fromContract(contract)
  const sortedVersions = contractContract.sortedVersions('desc')
  const activityPeriods = contract.activityPeriods

  return (
    <Box flexDirection="column" alignItems="flexStart" position="relative" width="full">
      {activityPeriods.map((period) => (
        <ActivityPeriod
          key={period.referenceVersionId}
          activityPeriod={period}
          contractVersionUpdates={period.changes?.updates || []}
          versions={sortedVersions}
          contract={contract}
          firstContract={firstContract}
          onContractVersionSelect={onContractVersionSelect}
          selectedContractVersionId={selectedContractVersionId}
          contractOngoingActivityPeriod={contractOngoingActivityPeriod}
          jobCatalogTreeLevelNodes={jobCatalogTreeLevelNodes}
        />
      ))}
    </Box>
  )
}

export default ContractView
